import { IOrganization } from '@/Interfaces';
import { IValidator, Validations } from '@samc/centricity-core';
import { validateEmail, validateAlphaNumeric } from './ValidateFunctions';

export class OrganizationValidator implements IValidator<IOrganization> {
  public isValid(value: IOrganization): Validations<IOrganization> {
    const validations: Validations<IOrganization> = {};
    
    if (value.name.length === 0) validations.name = 'Name is required!';
    if (value.moniker.length === 0) validations.moniker = 'Moniker is required!';
    if (value.moniker.length > 20) validations.moniker = 'Moniker length can have maximum 20 characters!';
    if (value.zip?.length > 15) validations.zip = 'Zip length can have maximum 15 characters!';
    if (value.contactPhone?.length > 25) validations.contactPhone = 'Contact Phone length can have maximum 25 characters!';    
    if (value.contactEmail?.length > 0 && !validateEmail(value.contactEmail)) validations.contactEmail = 'Contact Email has invalid email address!';
    if (value.itContactPhone?.length > 25) validations.itContactPhone = 'IT Contact Phone length can have maximum 25 characters!';
    if (value.itContactEmail?.length > 0 && !validateEmail(value.itContactEmail)) validations.itContactEmail = 'IT Contact Email has invalid email address!';

    if (value.clientCounterpartyId1?.length > 100) validations.clientCounterpartyId1 = 'Client CP ID 1 length can have maximum 100 characters!';
    if (value.clientCounterpartyId1?.length > 0 && !validateAlphaNumeric(value.clientCounterpartyId1)) validations.clientCounterpartyId1 = 'Client CP ID 1 should contain only letters and numbers!';

    if (value.clientCounterpartyId2?.length > 100) validations.clientCounterpartyId2 = 'Client CP ID 2 length can have maximum 100 characters!';
    if (value.clientCounterpartyId2?.length > 0 && !validateAlphaNumeric(value.clientCounterpartyId2)) validations.clientCounterpartyId2 = 'Client CP ID 2 should contain only letters and numbers!';

    if (value.clientCounterpartyId3?.length > 100) validations.clientCounterpartyId3 = 'Client CP ID 3 length can have maximum 100 characters!';
    if (value.clientCounterpartyId3?.length > 0 && !validateAlphaNumeric(value.clientCounterpartyId3)) validations.clientCounterpartyId3 = 'Client CP ID 3 should contain only letters and numbers!';

    if (value.isRateLock && !value.rateLockCounterpartyId) validations.rateLockCounterpartyId = 'Rate Lock CP ID is required!';

    if (value.sboCounterpartyId?.length > 10) validations.sboCounterpartyId = 'SBO CP ID length can have maximum 10 characters!';
    return validations;
  }
}
